export default __webpack_public_path__ + "static/media/pengucharacter.7406aa07.png";